import { Alert, Button, ButtonRow, Heading } from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import { getSelectedLanguage } from '@frontend/translate';
import { LoginMfaHelpFooter } from '../../elements/LoginMfaHelpFooter';
import { MfaCodeInput } from './MfaCodeInput';
import { MfaQrCodeForm } from './MfaQrCodeForm';

enum MfaView {
    enterMfa = 'enterMfa',
    qrCode = 'qrCode',
}

interface IScanMfaQrCodeProps {
    activationToken?: string;
    goBack: () => void;
    goToNextStep: () => void;
    noLoggedIn?: boolean;
    password?: string;
    userName?: string;
}

export function ScanMfaQrCode(props: IScanMfaQrCodeProps) {
    const translate = getSelectedLanguage();
    const [otpSecret, setOtpSecret] = useState<string>();
    const [faqTimeoutExpired, setFaqTimeoutExpired] = useState<boolean>(false);
    const [view, setView] = useState<MfaView>(MfaView.qrCode);

    useEffect(() => {
        setTimeout(() => setFaqTimeoutExpired(true), 1000 * 60 * 5); // 5 minutes
    }, []);

    return (
        <>
            <Heading>{props.activationToken ? 'Account activeren' : 'Tweestapsverificatie instellen'}</Heading>

            {view === MfaView.qrCode && (
                <>
                    <MfaQrCodeForm
                        activationToken={props.activationToken}
                        onOtpSecretChange={(newOtp) => setOtpSecret(newOtp)}
                        password={props.password}
                        userName={props.userName}
                    />

                    {faqTimeoutExpired && getFaqMessage()}

                    <ButtonRow>
                        <Button
                            color="secondary"
                            isDisabled={!otpSecret}
                            onClick={() => setView(MfaView.enterMfa)}
                            width="full"
                        >
                            {translate.common.next}
                        </Button>
                        <Button
                            color="secondary"
                            onClick={() => props.goBack()}
                            variant="outline"
                            width="full"
                        >
                            {translate.common.previous}
                        </Button>
                    </ButtonRow>
                </>
            )}
            {view === MfaView.enterMfa && (
                <>
                    {otpSecret && (
                        <MfaCodeInput
                            activationToken={props.activationToken}
                            onCodeVerified={onMfaVerified}
                            otpSecret={otpSecret}
                            password={props.password}
                            userName={props.userName}
                        />
                    )}

                    {faqTimeoutExpired && getFaqMessage()}

                    <Button
                        color="secondary"
                        onClick={() => props.goBack()}
                        variant="outline"
                        width="full"
                    >
                        {translate.common.previous}
                    </Button>
                </>
            )}
            <LoginMfaHelpFooter instructionsVideo="app" />
        </>
    );

    function getFaqMessage() {
        return (
            <Alert
                appearance="warning"
                noMargin={true}
            >
                Lukt het niet om je code in te vullen?
                <Alert.Link
                    href="https://www.ksyos.nl/contact/faq"
                    openInNewTab={true}
                    variant="externalLink"
                >
                    {' '}
                    Lees onze FAQ
                </Alert.Link>
            </Alert>
        );
    }

    function onMfaVerified() {
        setTimeout(() => {
            props.goToNextStep();
        }, 2000);
    }
}
